export const BASKET_ADD = 'basket.BASKET_ADD';
export const BASKET_UPDATE = 'basket.BASKET_UPDATE';
export const BASKET_REMOVE_PRODUCT = 'basket.BASKET_REMOVE_PRODUCT';
export const BASKET_CLEAR = 'basket.BASKET_CLEAR';
export const OPEN_BASKET = 'basket.OPEN_BASKET';
export const CLOSE_BASKET = 'basket.CLOSE_BASKET';


// WEBPACK FOOTER //
// ./src/types/basket.js